import { EnvelopeAccountSettingsModalQuery } from './graphql/accountSettingsModal.generated';

import { LegalAccountOwnershipType, LegalAccountTaxationType } from '../../../graphql/schema';

type SubAccounts = Extract<
  EnvelopeAccountSettingsModalQuery['envelopeAccount'],
  { __typename: 'ManagedAccount' }
>['subAccounts'];

export function formatTCPAccounts(subAccounts: SubAccounts) {
  const tcpAccounts = subAccounts.map(account =>
    formatLegalAccountType({
      ownershipType: account.legalAccount.ownershipType,
      taxationType: account.legalAccount.taxationType,
    })
  );

  if (tcpAccounts.length === 1) {
    return tcpAccounts[0];
  }

  if (tcpAccounts.length === 2) {
    return tcpAccounts.join(' and ');
  }

  const allButLast = tcpAccounts.slice(0, -1).join(', ');
  const lastAccount = tcpAccounts.slice(-1)[0];
  return `${allButLast}, and ${lastAccount}`;
}

export function formatLegalAccountType({
  ownershipType,
  taxationType,
}: {
  ownershipType: LegalAccountOwnershipType;
  taxationType: LegalAccountTaxationType;
}) {
  switch (taxationType) {
    case LegalAccountTaxationType.Roth_401K:
      return 'Roth 401(k)';
    case LegalAccountTaxationType.Traditional_401K:
      return 'Traditional 401(k)';
    case LegalAccountTaxationType.RothIra:
      return 'Roth IRA';
    case LegalAccountTaxationType.TraditionalIra:
      return 'Traditional IRA';
    case LegalAccountTaxationType.SepIra:
      return 'SEP IRA';
    case LegalAccountTaxationType.Hsa:
      return 'HSA';
    case LegalAccountTaxationType.Holding_529:
      return '529 Plan';
    case LegalAccountTaxationType.Taxable:
    default:
      if (ownershipType === LegalAccountOwnershipType.Joint) return 'Joint taxable';
      if (ownershipType === LegalAccountOwnershipType.Trust) return 'Trust taxable';

      return 'Individual taxable';
  }
}
